import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../../styles/pages/Admin/AdminLogin.scss';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');
  
  const navigate = useNavigate();
  
  // Definir mensagem inicial
  useEffect(() => {
    setStatusMessage('Por favor, faça login para acessar o painel administrativo');
  }, []);
  
  // Login offline local
  const performLogin = async (username, password) => {
    // Verificar se os campos estão preenchidos
    if (!username || !password) {
      throw new Error('Os campos de usuário e senha são obrigatórios');
    }
    
    // URL do backend baseada em variável de ambiente ou fallback para localhost
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    
    // Fazer requisição ao backend para autenticar
    const response = await fetch(`${API_URL}/api/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ username, password })
    });
    
    if (!response.ok) {
      // Tratar erros HTTP
      if (response.status === 401) {
        throw new Error('Credenciais inválidas. Verifique seu usuário e senha.');
      } else {
        throw new Error('Erro ao tentar autenticar. Tente novamente mais tarde.');
      }
    }
    
    // Processar a resposta bem-sucedida
    const data = await response.json();
    return data;
  };
  
  // Autenticação simplificada
  const handleLogin = async (e) => {
    e.preventDefault();
    console.log('Formulário submetido - Iniciando login');
    setError('');
    setLoading(true);
    
    // Validação simples dos campos
    if (!username.trim() || !password.trim()) {
      setError('Por favor, preencha todos os campos');
      setLoading(false);
      return;
    }
    
    try {
      setStatusMessage('Autenticando...');
      setLoading(true);
      
      // Autenticar através do backend
      const response = await performLogin(username, password);
      console.log('Autenticação bem-sucedida');
      
      if (response && response.token) {
        // Armazena os dados de autenticação
        const authData = {
          token: response.token,
          user: response.user,
          expiresAt: response.expiresAt || (Date.now() + 24 * 60 * 60 * 1000)
        };
        
        // Salva no localStorage
        localStorage.setItem('lunaAdmin', JSON.stringify(authData));
        
        setStatusMessage('Login bem-sucedido! Redirecionando...');
        
        // Redireciona para o painel
        setTimeout(() => {
          navigate('/admin/panel');
        }, 1000);
      } else {
        console.error('Resposta sem token de autenticação');
        setError('Erro de autenticação, tente novamente');
      }
    } catch (err) {
      console.error('Erro na autenticação:', err);
      setStatusMessage('Falha na autenticação');
      setError(err.message || 'Erro ao tentar fazer login');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="admin-page login-page">
      <motion.div 
        className="admin-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className="admin-header">
          <div>
            <h1>Área Administrativa</h1>
            <p>Luna Pijamas - Painel de Controle</p>
            {statusMessage && <p className="status-message">{statusMessage}</p>}
            <p className="admin-note">
              Área restrita. Acesso permitido apenas para administradores autorizados.
            </p>
          </div>
        </div>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
        <form className="admin-form" onSubmit={handleLogin} method="POST" noValidate>
          <div className="form-group">
            <label htmlFor="username">Usuário</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Digite seu usuário"
              autoFocus
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Digite sua senha"
            />
          </div>
          
          <div className="form-actions">
            <button
              type="submit" 
              className={`admin-button ${loading ? 'loading' : ''}`}
              disabled={loading}
            >
              {loading ? 'Aguarde...' : 'Entrar'}
            </button>
          </div>
        </form>
        
        <div className="admin-footer">
          <p>© {new Date().getFullYear()} Luna Pijamas</p>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin; 